module.exports = __webpack_public_path__ + "static/media/outline-p10-white.0a39a3ae.png";